export enum AppService {
  My1C = 'My1C',
  MyA = 'MyA',
  MyCC = 'MyCC',
  MyUC = 'MyUC',
  DCD = 'DCD',
}
